import { FeedPageComponent } from './FeedPageComponent';
import { configReducer } from '../../store/config/config.reducer';
import { footerReducer } from '../../store/footer/footer.reducer';
import { primaryHeaderReducer } from '../../store/primaryHeader/primaryHeader.reducer';
import { secondaryHeaderReducer } from '../../store/secondaryHeader/secondaryHeader.reducer';
import { feedPageReducer } from '../../store/template/feedPage/feedPage.reducer';
import {
    getAdSlots,
    getCategory, getDfpProperty,
    getHeaderBidderPublisherID,
    getLanguage,
    getSiteName,
    getTemplateName,
} from '../../store/config/config.selectors';
import { TemplateRegistration } from '../templateRegistration';
import { AppState } from '../../store/initialStateRegistration';
import { injectButtonToFooterLinksSectionEvent, injectVideoLogoEvent } from '../../client/clientAPI/events';
import { getCountryCode } from '../templates.utils';

export const rootReducer = {
    config: configReducer,
    footer: footerReducer,
    primaryHeader: primaryHeaderReducer,
    secondaryHeader: secondaryHeaderReducer,
    template: feedPageReducer,
};

const getCoreParams = (state: AppState) => ({
    property: getSiteName(state),
    language: getLanguage(state),
    category: getCategory(state),
    pageType: getTemplateName(state),
    adSlots: getAdSlots(state),
    headerBidderPublisherID: getHeaderBidderPublisherID(state),
    countryCode: getCountryCode(),
    dfpProperty: getDfpProperty(state),
});

export const FeedPage = new TemplateRegistration()
    .setComponent(FeedPageComponent)
    .setRootReducer(rootReducer)
    .setCoreParams(getCoreParams)
    .addClientAPIEvent(injectVideoLogoEvent)
    .addClientAPIEvent(injectButtonToFooterLinksSectionEvent)
    .build();
